<script>
    import rpcjs from 'rpcjs';
    const {goto} = rpcjs.props;
    let controller = 'controller';
    let rightdiv = 'rightdiv';
    let leftdiv = 'leftdiv';
    import {onMount} from 'svelte';
    /**
     */
    function onStart() {
        controller = 'controllerafter';
        leftdiv = 'leftdivafter';
        rightdiv = 'rightdivafter';
    }
    onMount(onMountFunction);
    /**
     */
    function onMountFunction() {
        setTimeout(onStart, 10);
    }
    /**
 * Adds two numbers together.
 */
    function next() {
        controller = 'controller';
        leftdiv = 'leftdiv';
        rightdiv = 'rightdiv';
        setTimeout(()=>{
            goto('/whygaming');
        }, 700);
    }
    /**
 * changes page.
 * @param {int} e The first number.
 */
    function keycheck(e) {
        e.preventDefault();
        if (e.key == 'ArrowRight') {
            next();
        }
        if (e.key == 'ArrowLeft') {
            goto('problem');
        }
    }
</script>

<svelte:window on:keyup={keycheck}/>
<div
role="presentation"
    class="maindiv"
    on:click={next}
>
    <div class={rightdiv}>
        <div class="img1">
            <img
                src="/images/solution/right.png"
                alt=""
                width="100%"
                height="100%"
            />
        </div>
        <div class="righttext">
            <div class="text1">
                <p>OPUS IS</p>
            </div>
            <div class="text2">
                <p>TEXT</p>
            </div>
            <div class="text3">
                <p>TO</p>
            </div>
            <div class="text4">
                <p>
                    VIDEO<br />GAMES.
                </p>
            </div>
            <div class="text5">
                <p>
                    100X REDUCTION<br /><span
                        style="font-size:1.563vw; font-weight:300"
                        >in time & cost.</span
                    >
                </p>
            </div>
        </div>
    </div>
    <div class={leftdiv} >
        <div class="img2">
            <img
                src="/images/solution/left.png"
                alt=""
                width="100%"
                height="100%"
            />
        </div>
        <div class="lefttext">
            <div class="lefttext1">
                <p>OPUS ECOSYSTEM IS</p>
            </div>
            <div class="lefttext2">
                <p>
                    WEB 3<br />
                    EXCLUSIVE
                </p>
            </div>
            <div class="lefttext3">
                <p>& SELF-SUSTAINING</p>
            </div>
            <div class="lefttext4">
                <p>Creating trust and certainty through</p>
            </div>
            <div class="lefttext5">
                <p>REAL WORLD USAGE</p>
            </div>
            <div class="lefttext6">
                <p>POSITIVE MESSAGING</p>
            </div>
            <div class="lefttext7">
                <p>CROSS-GAME ECONOMY</p>
            </div>
        </div>
    </div>
    <div class={controller}>
        <img
            src="/images/solution/controller.png"
            alt=""
            width="100%"
            height="100%"
        />
    </div>
</div>

<style>
    p {
        margin: 0;
        font-family: "Montserrat";
    }
    .maindiv {
        position: relative;
        display: flex;
        overflow: hidden;
        background-color: #101428;
        height: 100vh;
    }

    .rightdiv {
        position: relative;
        transition-duration: 1s;
        left:-50vw;
        background: #101428;
    }
    .rightdivafter {
        position: relative;
        transition-duration: 1s;
        left: 0vw;
        background: #101428;
    }
    .img1 {
        width: 50vw;
        height: 56.25vw;
    }
    .text1 {
        color: white;
        font-weight: 700;
        font-size: 1.563vw;
    }
    .text2 {
        color: #ff007f;
        font-weight: 700;
        font-size: 5.208vw;
        margin-top: -1vw;
    }
    .text3 {
        color: white;
        font-weight: 700;
        margin-left: 10.6vw;
        font-size: 2.083vw;
        margin-top: -1vw;
    }
    .text4 {
        color: #ff007f;
        font-weight: 900;
        font-size: 6.25vw;
        line-height: 6.25vw;
    }
    .text5 {
        color: white;
        font-weight: 900;
        font-size: 2.083vw;
        margin-top: min(6vw, 10.667vh);
        margin-left: -0.5vw;
        line-height: 1.5vw;
    }

    .righttext {
        position: absolute;
        top: min(10.052vw, 17.87vh);
        left: 9.792vw;
    }

    .leftdiv {
        position: relative;
        transition-duration: 1s;
        left:50vw;
        background-color: #FF007F;
    }
    .leftdivafter {
        position: relative;
        transition-duration: 1s;
        left: 0vw;
        background-color: #FF007F;
    }
    .img2 {
        width: 50vw;
        height: 56.25vw;
    }
    .lefttext {
        position: absolute;
        top: min(10.052vw, 17.87vh);
        left: 5.469vw;

    }
    .lefttext1 {
        color: white;
        font-weight: 700;
        font-size: 1.563vw;
    }
    .lefttext2 {
        color: #101428;
        font-weight: 900;
        font-size: 6.25vw;
        line-height: 6.25vw;
    }
    .lefttext3 {
        color: white;
        font-weight: 700;
        margin-left: 2.6vw;
        font-size: 3.333vw;
    }
    .lefttext4 {
        color: white;
        font-size: 1.563vw;
        font-weight: 300;
        margin-left: 12vw;
        margin-top: min(8.542vw, 15.185vh);
    }
    .lefttext5 {
        color: white;
        font-weight: 900;
        font-size: 2.083vw;
        margin-left: 16.7vw;
    }
    .lefttext6 {
        color: white;
        font-weight: 900;
        font-size: 2.083vw;
        margin-left: 15.89vw;
    }
    .lefttext7 {
        color: white;
        font-weight: 900;
        font-size: 2.083vw;
        margin-left: 13.3vw;
    }

    .controller {
        position: absolute;
        width: 35.938vw;
        height: 23.906vw;
        left: 32vw;
        top: 60vw;
        transition-duration: 1.5s;
    }
    .controllerafter {
        position: absolute;
        width: 35.938vw;
        height: 23.906vw;
        left: 32vw;
        top: 35vw;
        transition-duration: 1.5s;
    }
</style>
